import { AnalyticsDashboard } from "../types";
import { TrendChart } from "./AnalyticsVisuals";

const MonthlyTrendChart = ({ dashboard }: { dashboard?: AnalyticsDashboard | null }) => <TrendChart dashboard={dashboard} />;

export default MonthlyTrendChart;
